<template>
  <div>
      <div class="crop-box clearfix">
        <div class="fl left">
            <div class="cropper">
                <vueCropper
                    v-show="options.img"
                    ref="cropper"
                    :img="options.img"
                    :outputType="options.outputType"
                    :autoCrop="options.autoCrop"
                    :autoCropWidth="options.autoCropWidth"
                    :autoCropHeight="options.autoCropHeight"
                    :fixed="options.fixed"
                    :fixedNumber="options.fixedNumber"
                    :fixedBox="options.fixedBox"
                    :centerBox="options.centerBox"
                    @realTime="realPrev"
                ></vueCropper>
                <label v-show="!options.img">
                    <div class="df left-up">
                        <div>
                            <div class="add">+</div>
                            <p>上传封面</p>
                        </div>
                        <div class="ft12">
                            <p>只支持JPG/PNG，大小不超过5M</p>
                            <p>建议尺寸为250X250</p>
                        </div>
                    </div>
                    <input type="file" class="file" id="file" @change="chooseFile" accept="image/jpg,image/png,image/jpeg,image/gif"/>
                </label>
            </div>
            <div class="handle clearfix">
                <span class="fl re-up" @click="reChoose">重新上传</span>
                <div class="fr">
                    <span class="handle-icon enlarge" @click="changeScale(1)"></span>
                    <span class="handle-icon shrink" @click="changeScale(-1)"></span>
                    <span class="handle-icon rotate" @click="rotateRight"></span>
                </div>
            </div>
        </div>
        <div class="fr right">
            <div class="prev-box">
                <div :style="previewStyle"> 
                    <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img">
                    </div>
                </div>
            </div>
            <p>头像预览</p>
        </div>
    </div>
    <Warn ref="warn"></Warn>
  </div>
</template>
<script>
import Warn from "../common/warn"
export default {
  components: {
    Warn
  },
  props: {
      isGetResult: {
          type: Boolean,
          default: false
      }
  },
  data(){
      return {
        options: {
        img: "",
        outputType: "png",   //剪切后输出的图片格式
        canScale: true,       //是否允许滚轮缩放,
        autoCrop: true,       //是否默认生成截图框
        autoCropWidth: 150,   //默认截图框宽度
        autoCropHeight: 150,  //默认截图框高度
        fixed: true,          //是否开启截图框固定宽度比例
        fixedNumber: [1,1],   //截图框比例
        fixedBox: false,       //固定截图框大小
        centerBox: true,      //截图框是否被限制在图片里面
        },
        previews: {},         //预览对象
        previewStyle: {},     //预览样式
        resultUrl: "",     //裁剪之后的url
      }
  },
  methods: {
      //选择图片    需做验证,是否为图片,图片大小验证
      chooseFile(el){
          var that = this;
          var file = el.target.files[0] || "";
          if(!file) return;
          if(!this.testImg(file)){
              //提示选择图片
              this.$refs.warn.message("请选择图片!");
              el.target.value = "";
              return;
          }
          if(file.size>(1024*1024*5)){
              //提示图片大小超去范围
              this.$refs.warn.message("图片大小不能超过5M!");
              el.target.value = "";
              return;
          }
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function(){
                var url = this.result;
                that.options.img = url;
            }
      },
      //重新选择
      reChoose(){
          document.getElementById("file").click();
      },
      //实时预览
      realPrev(data){
          this.previews = data;
          this.previewStyle = {
              width: this.previews.w + "px",
              height: this.previews.h + "px",
              overflow: "hidden",
              zoom: 92 / this.previews.w,
              borderRadius: "50%"
          };
      },
      //放大缩小,正数放大,负数缩小
      changeScale(num){
        this.$refs.cropper.changeScale(num);
      },
      //向右旋转图片90°
      rotateRight(){
        this.$refs.cropper.rotateRight();
      },
      //确定裁剪
      getResult(){
        var that = this;
        this.$refs.cropper.getCropData(data=>{
            //let img = window.URL.createObjectURL(data);
            let img = data;
            that.resultUrl = img;
            that.$emit('getAvatar',{isShow: false, url: img});
            that.resetCrop();
        });
      },
      //取消裁剪
      cancelCrop(){
        this.resultUrl = "";
        this.$emit('getAvatar',{isShow: false, url: this.resultUrl});
        this.resetCrop();
      },
      //重置crop
      resetCrop(){
          this.options.img = "";
          this.previews = {};
          this.previewStyle = {};
      },
      //检测是否为图片
        testImg(file){
            var res = /\.(jpe?g|png|gif|webp|bmp|tiff)/;
            if(res.test(file.name)){
                return true;
            }
            return false;
        },
        //关闭提示框
        closeWarn(data){
            this.$refs.warn.closeWarn();
        },
  },
  watch: {
      isGetResult: {
          handler: function(){
              if(this.isGetResult){
                  this.getResult();
              }
          }
      }
  }
}
</script>
<style scoped>
.crop-box{
    margin: 0 124px;
}
.left{
    width: 250px;
}
.cropper{
    height: 250px;
    position: relative;
}
.handle{
    line-height: 32px;
    font-size: 14px;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}
.handle-icon{
    display: inline-block;
    width: 14px;
    height: 13px;
    margin-left: 15px;
    cursor: pointer;
}
.enlarge{
    background: url(../../assets/img/enlarge_icon.png) no-repeat;
}
.enlarge.active{
    background: url(../../assets/img/enlarge_icon.png) no-repeat;
}
.shrink{
    background: url(../../assets/img/shrink_icon.png) no-repeat;
}
.shrink.active{
    background: url(../../assets/img/shrink_icon_h.png) no-repeat;
}
.rotate{
    background: url(../../assets/img/rotate_icon.png) no-repeat;
}
.rotate.active{
    background: url(../../assets/img/rotate_icon_h.png) no-repeat;
}
.re-up{
    cursor: pointer;
}
.crop-box .left-up{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    background-color: #f2f3f4;
}
.crop-box .ft12{
    font-size: 12px;
    margin-top: 20px;
}
.crop-box .add{
    width: 40px;
    height: 40px;
    line-height: 36px;
    border-radius: 50%;
    background-color: #ff9933;
    color: #fff;
    font-size: 36px;
    display: inline-block;
    margin-bottom: 5px;
}
.crop-box .file{
    display: none;
    opacity: 0;
}
.right{
    width: 92px;
    text-align: center;
}
.prev-box{
    height: 92px;
    border-radius: 50%;
    background-color: #f2f3f4;
}
.right>p{
    font-size: 14px;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/accountsetting/changeavatar.vue